module.exports = __webpack_public_path__ + "static/media/ipk2022_special_guests_3.26f028d8.png";